// src/utils/types.tsx
typeAssertIs()();
typeAssertIs()();
typeAssertIs()();
function typeAssert() {
  return () => void 0;
}
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
function typeAssertExtends() {
  return () => void 0;
}
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
function typeAssertIs() {
  return () => void 0;
}
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
typeAssertExtends()();
export {
  typeAssert,
  typeAssertExtends,
  typeAssertIs
};
//# sourceMappingURL=types.js.map